import type { OrganisationDto } from '@dhl/mdp-api'
import { convertToOrganisationData, type Organisation } from '~/modules/organisations/model'
import { isCccBusinessUnit } from '~/common/model/businessunits'

export const convertToOrganisation = (organisationDto: OrganisationDto): Organisation => ({
  ...organisationDto,
  data: convertToOrganisationData(organisationDto.data),
  ccc: organisationDto.ccc
    ? organisationDto.ccc
    : isCccBusinessUnit(organisationDto.businessUnitCode)
      ? { customerId: '', billingUnitId: '' }
      : undefined,
})
